import { Box, Image } from '@chakra-ui/react'
import React from 'react'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { ChakraBox } from './aidesigner'


export const ZoomImage = ({ id, src, fallbackSrc, width = "256px", height = "256px", hasHeight = true, zoom = true, ...props }) => {


  return (
    <>
      {src && src.length > 0 ?
        <>
          {zoom ?
            <Zoom>
              <Image
                crossorigin="anonymous"
                src={src}
                width={width}
                {...props}
              />
            </Zoom>
            :
            <Image
              crossorigin="anonymous"
              src={src}
              width={width}
              {...props}
            />
          }
        </>
        :

        <Box
          width={width}
          {...props}
        >

          <ChakraBox id="cbox" width={width} height={height} margin={0} padding={0}
            animate={{
              opacity: [0, 1],
            }}
            transition={{
              duration: 3,
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "loop",
            }}
            padding="2"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            Generating
          </ChakraBox>
        </Box>
      }
    </>
  )
}